import {
  ChartDonutIcon,
  LayoutOutlineIcon,
  RowIcon,
} from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';
import { ModificationItem } from './ModificationItem';
import { getImageFileName, isSvg } from './utils';

const iconByValue = (name: string) => {
  if (name === 'Box')
    return (
      <LayoutOutlineIcon
        size={24}
        color={ColorHex.primary300}
      />
    );
  if (name === 'List Item')
    return (
      <RowIcon
        size={24}
        color={ColorHex.primary300}
      />
    );
  if (name === 'Chart')
    return (
      <ChartDonutIcon
        size={24}
        color={ColorHex.primary300}
      />
    );
  if (isSvg(name)) return <span className="text-ds-50">SVG</span>;

  return undefined;
};
export const ImageModificationItem = ({
  edit,
}: {
  edit: IDynamicEditData['element'];
}) => {
  const valueName = edit.old.serialized?.renameValue ?? edit.old.value;
  const icon = iconByValue(valueName);
  const isSvgImage = isSvg(valueName);
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon backgroundImageUrl={!icon && valueName}>
          {icon}
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={isSvgImage ? 'SVG' : getImageFileName(valueName)}
        />
      </ModificationItem.Content>
      <ModificationItem.Arrow />
      <ModificationItem.Content>
        <ModificationItem.Icon backgroundImageUrl={edit.new.value} />
        <ModificationItem.Text label={getImageFileName(edit.new.value)} />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
